import { render } from "./Footer.vue?vue&type=template&id=46b1bc6f"
const script = {}

import exportComponent from "/var/www/dental/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__